import {
  ModuleItemType,
  ModuleTemplateTypeEnum,
} from "@packages/flow-core/module";
import { FlowNodeTypeEnum } from "@packages/flow-core/module/node/constants";
import {
  FlowNodeInputItemType,
  FlowNodeOutputItemType,
} from "@packages/flow-core/module/node/types";

export const generate_init_plugin_modules = (
  inputId: string,
  outputId: string
): ModuleItemType[] => {
  return [
    {
      moduleId: inputId,
      templateType: ModuleTemplateTypeEnum.getContent,
      name: "输入参数设置",
      description: "设置子流程的输入参数",
      avatar:
        "https://actstatic.insnail.com/workflow/imgs/module/plugin-input.svg",
      flowType: FlowNodeTypeEnum.pluginInput,
      position: { x: 630, y: 520 },
      inputs: [] as FlowNodeInputItemType[],
      outputs: [] as FlowNodeOutputItemType[],
    },
    {
      moduleId: outputId,
      templateType: ModuleTemplateTypeEnum.getContent,
      name: "输出参数设置",
      description: "设置子流程的输出参数",
      avatar:
        "https://actstatic.insnail.com/workflow/imgs/module/plugin-output.svg",
      flowType: FlowNodeTypeEnum.pluginOutput,
      position: { x: 1400, y: 520 },
      inputs: [],
      outputs: [],
    },
  ];
};
